
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Upload, RefreshCcw } from 'lucide-react';

interface MediaLibrarySearchProps {
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  onAIOrganize?: () => void;
  setShowUploadDialog?: (show: boolean) => void;
  showUploadDialog?: boolean;
  onSearch: (query: string) => void;
}

const MediaLibrarySearch: React.FC<MediaLibrarySearchProps> = ({
  searchQuery = '',
  setSearchQuery,
  onAIOrganize,
  setShowUploadDialog,
  showUploadDialog,
  onSearch
}) => {
  const [localSearchQuery, setLocalSearchQuery] = React.useState(searchQuery);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newQuery = e.target.value;
    setLocalSearchQuery(newQuery);
    
    if (setSearchQuery) {
      setSearchQuery(newQuery);
    }
    
    onSearch(newQuery);
  };

  const handleAIOrganize = () => {
    if (onAIOrganize) {
      onAIOrganize();
    }
  };

  const handleOpenUploadDialog = () => {
    if (setShowUploadDialog) {
      setShowUploadDialog(true);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input 
          placeholder="Search your media..." 
          className="pl-9"
          value={localSearchQuery}
          onChange={handleSearch}
        />
      </div>
      
      <div className="flex gap-2">
        <Button onClick={handleOpenUploadDialog} className="gap-2">
          <Upload className="h-4 w-4" />
          <span>Upload</span>
        </Button>
        
        <Button variant="outline" className="gap-2" onClick={handleAIOrganize}>
          <RefreshCcw className="h-4 w-4" />
          <span>AI Organize</span>
        </Button>
      </div>
    </div>
  );
};

export default MediaLibrarySearch;
